import * as apple from 'js/apple'

export const loginWithApple = () => {
  return apple.login().then(({ access_token, expires_at }) => {
    return { access_token, expires_at }
  })
}
